import React, { Component } from "react";
import ProductInfoItem from './ProductInfoItem';

export default class ProductInfo extends Component {
	render () {
		if (this.props.item.info) {
			const sections = this.props.item.info.map((info,i) =>
				<div key={i} className="c-accordion__section">
					<ProductInfoItem info={info}></ProductInfoItem>
				</div>
			);
			return (
				<div className="c-accordion">
					{ sections }
				</div>
			);
		} else {
			return null;
		}
	}
}